import { Events } from '@platform/client';
import { Dropdown, DropdownItem } from '@platform/components';
import { useState } from 'react';
import { CommunityBackButton } from '../community-home/CommunityBackButton';
import { CommunityListPanel } from '../CommunityListPanel';
import { CommunityPaginationBar } from '../CommunityPaginationBar';
import { EventCard } from './EventCard';

export const EventsPage = () => {
  const [page, setPage] = useState(0);
  const [pageSize, _] = useState(8);

  const onPageSelect = (page: number) => {
    setPage(page - 1);
  };

  const upcomingEvents = Events.useGetUpcomingEvents({
    limit: pageSize,
    page,
    sort: 'end_time:DESC',
  });
  const pastEvents = Events.useGetPastMovingworldsEvents({ limit: pageSize, page });

  const [activeTab, setActiveTab] = useState<'past' | 'upcoming'>('upcoming');

  const events = activeTab === 'past' ? pastEvents.data : upcomingEvents.data;
  const numPages = Math.ceil((events?.length || pageSize) / pageSize);

  return (
    <div className='p-4 flex flex-col w-full pt-10 w-[317px] max-w-[317px] md:w-[798px] md:max-w-[798px]'>
      <CommunityBackButton />
      <h1 className='text-display-md text-gray-700 py-10'>Events</h1>
      <div className='hidden md:flex flex-row justify-center gap-2 border-b border-gray-100'>
        <div
          onClick={() => {
            setActiveTab('upcoming');
          }}
          className={`font-semibold w-[240px] cursor-pointer`}
        >
          <div
            className={`${
              activeTab === 'upcoming' ?
                'text-brand-600 border-b-2 border-brand-600'
              : 'text-gray-400'
            } inline-block h-[36px]`}
          >
            Upcoming events
          </div>
        </div>
        <div
          onClick={() => {
            setActiveTab('past');
          }}
          className={`font-semibold w-[240px] cursor-pointer`}
        >
          <div
            className={`${
              activeTab === 'past' ? 'text-brand-600 border-b-2 border-brand-600' : 'text-gray-400'
            } inline-block h-[36px]`}
          >
            Past MovingWorlds events
          </div>
        </div>
      </div>
      <div className='block md:hidden pb-16'>
        <Dropdown
          type='button'
          ariaLabel='Events Dropdown'
          buttonProps={{
            variant: 'secondary-gray',
            size: 'lg',
            /* Disable the default tertiary-gray button styles. */
            children: (
              <div className='p-4'>
                {activeTab === 'upcoming' ? 'Upcoming Events' : 'Past Events'}
              </div>
            ),
          }}
        >
          <DropdownItem
            onAction={() => {
              setActiveTab('upcoming');
            }}
          >
            Upcoming Events
          </DropdownItem>
          <DropdownItem
            onAction={() => {
              setActiveTab('past');
            }}
          >
            Past Events
          </DropdownItem>
        </Dropdown>
      </div>
      <div className='w-full md:mt-8'>
        <CommunityListPanel>
          {events?.map((event) => {
            return <EventCard event={event} key={event.id} />;
          })}
        </CommunityListPanel>
      </div>
      <CommunityPaginationBar
        onPageSelect={onPageSelect}
        numPages={numPages}
        currentPage={page + 1}
      />
    </div>
  );
};
